var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6541",
    "data-name": "Groupe 6541",
    transform: "translate(-793 -6113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2757",
    "data-name": "Rectangle 2757",
    width: 22,
    height: 22,
    rx: 11,
    transform: "translate(793 6113)",
    fill: "#d9fdf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2757_-_Contour",
    "data-name": "Rectangle 2757 - Contour",
    d: "M11,1A10,10,0,1,0,21,11,10.011,10.011,0,0,0,11,1m0-1A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    transform: "translate(793 6113)",
    fill: "#3ac1ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5677",
    "data-name": "Trac\\xE9 5677",
    d: "M-4511.574,4496.028a.5.5,0,0,1-.354-.146l-2.706-2.706a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l2.353,2.352,7.036-7.036a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-7.389,7.39A.5.5,0,0,1-4511.574,4496.028Z",
    transform: "translate(5313.489 1632.379)",
    fill: "#3ac1ae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.5df72a3d24b1c00ac139be2f5fcf6f81.svg";
export { ForwardRef as ReactComponent };